	export enum AdditionalTaxRateUseEnum {
		Overwrite = 1,
		Add = 2
	}
